module.exports = __webpack_public_path__ + "img/undraw_Hiring_re_yk5n.257b26cc.svg";